module.exports = __webpack_public_path__ + "static/media/well-done-icon.f32f47f2.png";